import type { AutorizacaoArEnvio } from '@/types/arbitral/envioArTypes';

/**
 * O envio está num desfecho que o SERVIDOR ainda vai mudar sozinho?
 *
 * É a régua do polling passivo, e por isso lê só o que vem da rede — a aba de checkout
 * aberta é estado do navegador e entra por fora.
 *
 * As duas janelas:
 * - `EMITINDO` — o gateway ainda está gerando a cobrança. Sem releitura, o card fica
 *   em "Preparando a cobrança…" até alguém dar F5, mesmo com o link já pronto.
 * - pago mas com a cobrança não liquidada — o webhook entrou e a liberação da carta
 *   ainda está sendo escrita; é a janela curta entre "pagou" e "liberado".
 */
export function esperaDesfechoDoServidor(envio: AutorizacaoArEnvio): boolean {
  if (envio.situacaoCobranca === 'EMITINDO') return true;
  return envio.estado === 'PAGO' && envio.situacaoCobranca !== 'PAGA';
}
